export const APP_CONFIG = {
  appName: 'Gallagher Communications',
  frontend: 'https://gbscomms.builtoncore.com',
  apiHash: 'https://gbscomms.builtoncore.com/api/1.0',
  api: '/api/2.0',
  trustModel: false,
  authHeaders: {
    xServiceProvider: 'gbscomms-frontend',
    'tenant-id': 'ae9ca403-986c-49d0-a106-a619e9df3d66',
    'consumer-id': 'ecf12355-8b85-4561-b4cb-493efa6cfc28',
  },
  provider: 'gbscomms-frontend',
  multilingual: false,
  showNotifications: false,
  showSearch: false,
  showHeroImages: false,
  contactEnabled: false,
  demoMode: false,
  chatEnabled: false,
  isDarkModeEnabled: true,
rePositionBenefitPageSidePanel: false,
  showPosts: false,
  gtm: 'GTM-PTT2QSC',
  copyright: '<small>&copy; ' + new Date().getFullYear() +
      ' Gallagher | All Rights Reserved.' + '<br />Powered by Core.' + '</small>',
  navigation: {
    navType: 'top',
    collapsibleSidenav: false,
    headerStyle: 'transparent',
    categoryNav: false
  },
  colors: {
    primary: '#0d6efd',
    secondary: '#213e78'
  },
  blurredBackground: true,
    auth: {
        routes: ['login'],
    },
};
